import VmpHeaderRight from './src/main';

/* istanbul ignore next */
VmpHeaderRight.install = function (Vue) {
  Vue.component(VmpHeaderRight.name, VmpHeaderRight);
};

export default VmpHeaderRight;
